import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=ae671e7a&scoped=true&"
import script from "./CompanyLogo.vue?vue&type=script&lang=ts&"
export * from "./CompanyLogo.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&id=ae671e7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae671e7a",
  null
  
)

export default component.exports